<div class="borrower-kpi">
  <mat-card>
    <mat-card-content>
      <dl>
        <dt [ngClass]="{ 'mat-headline-5': creditLimit != null }">
          <!-- If amount is not nullish... -->
          @if (isLoading) {
            <mat-spinner diameter="20"></mat-spinner>
          } @else if (creditLimit != null) {
            {{ creditLimit | currency }}
          } @else if (creditLimit === null) {
            <mat-icon>error</mat-icon>Not available
          }
        </dt>
        <dd class="mat-body-2">Credit Limit</dd>
      </dl>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-content>
      <dl>
        <dt [ngClass]="{ 'mat-headline-5': creditInUse != null }">
          <!-- If amount is not nullish... -->
          @if (isLoading) {
            <mat-spinner diameter="20"></mat-spinner>
          } @else if (creditInUse != null) {
            {{ creditInUse | currency }}
          } @else if (creditInUse === null) {
            <mat-icon>error</mat-icon>Not available
          }
        </dt>
        <dd class="mat-body-2">
          Credit In Use
          <span class="mat-subtitle-2">(may adjust with pending payments)</span>
        </dd>
      </dl>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-content>
      <dl>
        <dt [ngClass]="{ 'mat-headline-5': authorizedHolds != null }">
          <!-- If amount is not nullish... -->
          @if (isLoading) {
            <mat-spinner diameter="20"></mat-spinner>
          } @else if (authorizedHolds != null) {
            {{ authorizedHolds | currency }}
          } @else if (authorizedHolds === null) {
            <mat-icon>error</mat-icon>Not available
          }
        </dt>
        <dd class="mat-body-2">Authorized Holds</dd>
      </dl>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-content>
      <dl>
        <dt [ngClass]="{ 'mat-headline-5': remainingCredit != null }">
          <!-- If amount is not nullish... -->
          @if (isLoading) {
            <mat-spinner diameter="20"></mat-spinner>
          } @else if (remainingCredit != null) {
            {{ remainingCredit | currency }}
          } @else if (remainingCredit === null) {
            <mat-icon>error</mat-icon>Not available
          }
        </dt>
        <dd class="mat-body-2">Remaining Credit</dd>
      </dl>
    </mat-card-content>
  </mat-card>
</div>